export default __webpack_public_path__ + "static/media/ghost-logo.c7b56414.svg";